import React, { useState } from "react";
import { doctors } from "../mock/data";
import { Quote, ArrowRight } from "lucide-react";

export default function Doctors() {
  const [active, setActive] = useState(0);
  const d = doctors[active];
  const isAnshu = d.name === "Dr. Anshu Singh";

  React.useEffect(() => {
    doctors.forEach((doctor) => {
      const img = new Image();
      img.src = doctor.photo;
      if (img.decode) {
        img.decode().catch(() => {});
      }
    });
  }, []);

  return (
    <section id="doctors" className="py-24 md:py-32 bg-[#f6f7f4]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8">
        <div className="text-center max-w-2xl mx-auto reveal">
          <div className="section-eyebrow">Meet the Doctors</div>
          <h2 className="mt-4 font-serif-display text-[42px] md:text-[62px] leading-[1.05] text-[#0e2b2b]">
            Led by <span className="hero-italic">specialists</span> who care
          </h2>
        </div>

        {/* Toggle tabs */}
        <div className="mt-10 flex justify-center gap-2">
          {doctors.map((doc, i) => (
            <button
              key={doc.name}
              onClick={() => setActive(i)}
              className={`px-5 py-2.5 rounded-full text-[13px] font-semibold tracking-wide transition ${active === i ? "bg-[#14a68e] text-white" : "bg-white text-[#0e2b2b]/70 border border-[#0e2b2b]/10 hover:border-[#14a68e]/40"}`}
            >
              {doc.name.replace("Dr. ", "Dr. ")}
            </button>
          ))}
        </div>

        <div className="mt-12 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <div className={`group relative aspect-[4/5] rounded-[36px] overflow-hidden isolate ${d.photoFit === "contain" || isAnshu ? "bg-[#eafafa]" : "bg-gradient-to-br from-[#0a1f1f] to-[#0e2b2b]"}`}>
              {d.photoFit === "contain" && <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_10%,rgba(20,166,142,0.18),transparent_60%)]" />}
              <img
                key={d.name}
                src={d.photo}
                alt={d.name}
                className={`absolute z-10 -inset-px w-[calc(100%+2px)] h-[calc(100%+2px)] transition-transform duration-700 ease-out group-hover:scale-105 ${d.photoFit === "contain" ? "object-contain object-bottom" : "object-cover brightness-110 contrast-105"}`}
              />
              {d.photoFit !== "contain" && <div className="absolute inset-0 bg-gradient-to-t from-[#0e2b2b]/40 via-transparent to-transparent z-20" />}
              <div className="absolute bottom-5 left-5 z-30 bg-white/95 backdrop-blur rounded-2xl px-4 py-3 shadow-lg">
                <div className="text-[10px] tracking-[0.22em] uppercase text-[#14a68e] font-semibold">Meet</div>
                <div className="font-serif-display text-[18px] text-[#0e2b2b] leading-tight">{d.name}</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <h3 className="font-serif-display text-[38px] md:text-[52px] leading-[1.05] text-[#0e2b2b]">{d.name}</h3>
            <div className="mt-2 text-[13px] tracking-[0.15em] uppercase text-[#14a68e] font-semibold">{d.role}</div>
            <p className="mt-6 text-[15px] md:text-[16px] text-[#0e2b2b]/75 leading-relaxed">{d.bio}</p>

            <div className="mt-8 relative bg-white rounded-2xl border border-[#0e2b2b]/10 p-6 md:p-7">
              <Quote className="absolute -top-4 left-6 w-8 h-8 text-[#14a68e]" />
              <p className="italic-serif text-[20px] md:text-[24px] text-[#0e2b2b] leading-snug">“{d.quote}”</p>
              <div className="mt-4 text-[12px] tracking-[0.18em] uppercase text-[#0e2b2b]/60">— {d.name}</div>
            </div>

            <div className="mt-8">
              <a href="#contact" className="btn-primary">Book with {d.name.split(" ").slice(0,2).join(" ")} <ArrowRight size={16} /></a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
